import styled from 'styled-components';

export const ButtonNoStyle = styled.button`
  border: none;
  background: none;
`;

export const Overlay = styled.div`
  background-color: #000;
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  transition: 0.3s;
  cursor: ${props => (props.invisible ? 'initial' : 'pointer')};

  &.active {
    z-index: 14;
    opacity: ${props => (props.invisible ? 0 : 0.3)};
    visibility: visible;
  }
`;
